// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Edited 5/15/20 Shao Dai
 * 
 */
:root {
  --white: #ffffff;
  --black: #000000;
  --grey-10: #F5F5F7;
  --grey-20: #DADFE3;
  --grey-30: #BAC0C2;
  --grey-40: #8D9599;
  --grey-50: #666D70;
  --grey-60: #3A4042;
  --grey-70: #232526;
  --purple-10: #FFFAFF;
  --purple-30: #C280BD;
  --purple-50: #9C258B;
  --purple-60: #771b61;
  --purple-70: #4F1140;
  --green-2: #D9E6C6;
  --green-3: #578319;
  --red-1: #FFF7F5;
  --red-2: #FCBFB3;
  --red-3: #DD2E0B;
  --teal-10: #F3FDFB;
  --teal-20: #A1E5D4;
  --teal-30: #7ED6C1;
  --teal-40: #27C4A5;
  --teal-50: #0E856D;
  --teal-60: #085243;
  --teal-70: #04382D;
  --orange-20: #FFB494;
  --orange-50: #D04A0A;
  --orange-60: #942F00;
  --orange-70: #591E03;
  --disabled-grey: #C6CACC;
  --transparent-black-10: rgba(0, 0, 0, 0.1);
  --transparent-black-85: rgba(0, 0, 0, 0.85);
  --transparent-white-10: rgba(255, 255, 255, 0.1);
  --transparent-white-85: rgba(255, 255, 255, 0.85);
}

/* Custom-formatted sass/css variables */
/* Updated 5/15/20 Shao Dai */
/* UPMC white */
/* UPMC black */
/* UPMC grey */
/* UPMC purple */
/* UPMC green */
/* UPMC red */
/* UPMC teal */
/* UPMC orange */
/* UPMC disabled */
/* UPMC transparent */
.error .unity-select-dropdown:not(.no-error), .error .unity-input-field {
  box-shadow: inset 0 0 0 2px #b22116;
}
.error .error-msg {
  margin: -6px 0 12px -13px;
  font-size: 11pt;
  color: #b22116;
  padding: 0 0 0 16px;
  position: relative;
  display: block;
  padding-top: 1em;
  animation: fadein 0.5s;
  -moz-animation: fadein 0.5s;
  -webkit-animation: fadein 0.5s;
  -o-animation: fadein 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.error .error-msg:before {
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIFSURBVEhLrZQxSxxREMfnze2CheAaUqQQzvM2hRC4CBYphKchhaUphED8ACmuECwtErBIkSYgFuks7EyRb3AsBFLJeSEgouFOuIildgfZ7MvM7tzFze7bVfEHdzP/2bt5/903b+GmtHW92VnyT74/97ekVIqSWEhH+88A4ZtIgAhWG8HpZ1FWUGIxCB8kS0B439XVMVFWSpsf6plXFBYSNcK/AqcpuZXCx9LS2nmAv44o9ZNKisso+l2bC84uRWcodO5B/w2FvMaMhxV3U/JcrM7buuopdI/oB48MwIUC80kuEeo1fflUH5ioMjsXHPeSehqrc0RnnRtzTvGw0fr5bvgh/VXqY4ihdTRzm//QVXa7IZIpmAy1dqBn5kWkyG3+B91NBWpcJONIjKGFU4s5iOlRFTLND3SdNtDwRl5nSuKQ+HFdY5FO8IrkIzLNHVTkQqWc3gREtcWjKzIm1ZxWX6SQccCPYXgiuYEB879z5okH52uSx9CG/6OzVG9T6anIW0OL9iei8HEtOBuwHjlPjnlRY7NHTnY58nxLMQUNwdQVuOsiE+clx5zpNVqnNcnpDv0uhelEZRi9FmLnk9Dn1WyNb4tXQectJ4qPOaLLTjwuWCA35qXkNBmwT399KDIHE4YRzCq6xW1Spa/PO/AFaYdfiLhXaNOX0USwY9v9u2NCpczHv0HaiotDFFoAAAAAAElFTkSuQmCC") no-repeat;
  background-size: 13px 13px;
  display: block;
  content: "";
  width: 13px;
  height: 13px;
  position: relative;
  left: 0;
  top: 4px;
  float: left;
  padding-right: 19px;
}

.no-break {
  page-break-inside: avoid;
}

/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the grey background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

*,
::before,
::after {
  box-sizing: border-box;
  background-repeat: no-repeat;
}

/* ::before,
::after {
  text-decoration: inherit; // S: Pseudo-elements inherit text-decoration and vertical-align.
  vertical-align: inherit;
} */
html {
  line-height: 1.6180339888;
  font-family: var(--ods-font-family);
  color: #3A4042;
  font-size: 14px;
  cursor: default;
  tab-size: 4;
}
@media print, (min-width: 1024px) {
  html {
    font-size: 16px;
  }
}

a,
button {
  cursor: pointer;
  text-decoration: none;
}

blockquote,
body,
dd,
dl,
fieldset,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
menu,
ol,
p,
pre,
ul {
  margin: 0;
}

fieldset,
legend,
ol,
ul {
  padding: 0;
}

nav ol,
nav ul {
  list-style: none;
}

::selection {
  background-color: #b3d4fc;
  color: #000;
  text-shadow: none;
}

audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

svg {
  fill: currentColor;
}

table {
  border-collapse: collapse;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

textarea {
  resize: vertical;
}

a,
area,
button,
input,
label,
select,
summary,
textarea,
[tabindex] {
  touch-action: manipulation;
}

[aria-busy=true] {
  cursor: progress;
}

[aria-controls] {
  cursor: pointer;
}

[aria-disabled],
[disabled] {
  cursor: default;
}

[aria-hidden=false][hidden]:not(:focus) {
  clip: rect(0, 0, 0, 0);
  display: inherit;
  position: absolute;
}

.address-container {
  margin-right: 1.5rem;
}

.unity-label--above {
  font-size: 13px;
  margin-top: 3px;
}
@media print, (min-width: 1024px) {
  .unity-label--above {
    font-size: 1rem;
    font-weight: 500;
    width: 100%;
    margin: 0 1rem 2px 0;
    line-height: 1.5em;
  }
}

ods-autosuggest::part(icon) {
  display: none;
}

ods-autosuggest::part(combobox) {
  padding-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/settings/_settings.variables.scss","webpack://./src/app/modules/main/components/location-search/location-search.component.scss","webpack://./src/assets/scss/settings/_settings.colors.scss","webpack://./src/assets/scss/settings/_settings.error.scss","webpack://./src/assets/scss/settings/_settings.print.scss","webpack://./src/assets/scss/settings/_generic.normalize.scss","webpack://./src/assets/scss/settings/_generic.base.scss","webpack://./src/assets/scss/settings/_settings.typography.scss","webpack://./src/assets/scss/settings/_settings.breakpoints.scss"],"names":[],"mappings":"AAAA;;;EAAA;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,0CAAA;EACA,2CAAA;EACA,gDAAA;EACA,iDAAA;ACAF;;ACxCA,wCAAA;AACA,6BAAA;AAEA,eAAA;AAGA,eAAA;AAGA,cAAA;AASA,gBAAA;AAOA,eAAA;AAIA,aAAA;AAKA,cAAA;AASA,gBAAA;AAMA,kBAAA;AAGA,qBAAA;AClDE;EACE,mCAAA;AFqDJ;AEnDA;EACE,yBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EAEA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;AFoDF;AElDE;EACA;IACA,UAAA;EFoDA;EElDA;IACA,UAAA;EFoDA;AACF;AEzBE;EACE,m3BAAA;EAEA,0BAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AFmDJ;;AGnHA;EAAW,wBAAA;AHuHX;;AIvHA,2EAAA;AAEA;+EAAA;AAGA;;;EAAA;AAKA;EACE,iBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;AJuHF;;AIpHA;+EAAA;AAGA;;EAAA;AAIA;EACE,SAAA;AJqHF;;AIlHA;;;EAAA;AAKA;EACE,cAAA;EACA,gBAAA;AJoHF;;AIjHA;+EAAA;AAGA;;;EAAA;AAKA;EACE,uBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;AJkHF;;AI/GA;;;EAAA;AAKA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AJiHF;;AI9GA;+EAAA;AAGA;;EAAA;AAIA;EACE,6BAAA;AJ+GF;;AI5GA;;;EAAA;AAKA;EACE,mBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,yCAAA;UAAA,iCAAA,EAAA,MAAA;AJ8GF;;AI3GA;;EAAA;AAIA;;EAEE,mBAAA;AJ6GF;;AI1GA;;;EAAA;AAKA;;;EAGE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AJ4GF;;AIzGA;;EAAA;AAIA;EACE,cAAA;AJ2GF;;AIxGA;;;EAAA;AAKA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AJ0GF;;AIvGA;EACE,eAAA;AJ0GF;;AIvGA;EACE,WAAA;AJ0GF;;AIvGA;+EAAA;AAGA;;EAAA;AAIA;EACE,kBAAA;AJwGF;;AIrGA;+EAAA;AAGA;;;EAAA;AAKA;;;;;EAKE,oBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;AJsGF;;AInGA;;;EAAA;AAKA;;EAEE,MAAA;EACA,iBAAA;AJqGF;;AIlGA;;;EAAA;AAKA;;EAEE,MAAA;EACA,oBAAA;AJoGF;;AIjGA;;EAAA;AAIA;;;;EAIE,0BAAA;AJmGF;;AIhGA;;EAAA;AAIA;;;;EAIE,kBAAA;EACA,UAAA;AJkGF;;AI/FA;;EAAA;AAIA;;;;EAIE,8BAAA;AJiGF;;AI9FA;;EAAA;AAIA;EACE,8BAAA;AJgGF;;AI7FA;;;;;EAAA;AAOA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AJ+FF;;AI5FA;;EAAA;AAIA;EACE,wBAAA;AJ8FF;;AI3FA;;EAAA;AAIA;EACE,cAAA;AJ6FF;;AI1FA;;;EAAA;AAKA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AJ4FF;;AIzFA;;EAAA;AAIA;;EAEE,YAAA;AJ2FF;;AIxFA;;;EAAA;AAKA;EACE,6BAAA,EAAA,MAAA;EACA,oBAAA,EAAA,MAAA;AJ0FF;;AIvFA;;EAAA;AAIA;EACE,wBAAA;AJyFF;;AItFA;;;EAAA;AAKA;EACE,0BAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;AJwFF;;AIrFA;+EAAA;AAGA;;EAAA;AAIA;EACE,cAAA;AJsFF;;AInFA;;EAAA;AAIA;EACE,kBAAA;AJqFF;;AIlFA;+EAAA;AAGA;;EAAA;AAIA;EACE,aAAA;AJmFF;;AIhFA;;EAAA;AAIA;EACE,aAAA;AJkFF;;AKraA;;;EAGE,sBAAA;EACA,4BAAA;ALwaF;;AKtaA;;;;GAAA;AAKA;EACE,yBAAA;EACA,mCCRW;EDSX,cJDQ;EIER,eCNgB;EDUhB,eAAA;EACA,WAAA;ALsaF;AO/ZE;EFhBF;IAMI,eCPe;ENobjB;AACF;;AKtaA;;EAEE,eAAA;EACA,qBAAA;ALyaF;;AKraA;;;;;;;;;;;;;;;;;;EAkBE,SAAA;ALwaF;;AKraA;;;;EAIE,UAAA;ALwaF;;AKtaA;;EAEE,gBAAA;ALyaF;;AKvaA;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AL0aF;;AKxaA;;;;;;EAME,sBAAA;AL2aF;;AKzaA;EACE,kBAAA;AL4aF;;AK1aA;EACE,yBAAA;AL6aF;;AK3aA;;;;EAIE,oBAAA;EACA,kBAAA;EACA,oBAAA;AL8aF;;AK5aA;EACE,gBAAA;AL+aF;;AK7aA;;;;;;;;;EAUE,0BAAA;ALgbF;;AK7aA;EACE,gBAAA;ALgbF;;AK7aA;EACE,eAAA;ALgbF;;AK7aA;;EAEE,eAAA;ALgbF;;AK7aA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;ALgbF;;AA3iBA;EACE,oBAAA;AA8iBF;;AA3iBA;EACE,eAAA;EACA,eAAA;AA8iBF;AOxhBE;EPxBF;IAII,eAAA;IACA,gBAAA;IACA,WAAA;IACA,oBAAA;IACA,kBAAA;EAgjBF;AACF;;AA7iBA;EACE,aAAA;AAgjBF;;AA7iBA;EACE,qBAAA;AAgjBF","sourcesContent":["/**\n * Edited 5/15/20 Shao Dai\n * \n */\n\n:root {\n  --white: #ffffff;\n  --black: #000000;\n  --grey-10: #F5F5F7;\n  --grey-20: #DADFE3;\n  --grey-30: #BAC0C2;\n  --grey-40: #8D9599;\n  --grey-50: #666D70;\n  --grey-60: #3A4042;\n  --grey-70: #232526;\n  --purple-10: #FFFAFF;\n  --purple-30: #C280BD;\n  --purple-50: #9C258B;\n  --purple-60: #771b61;\n  --purple-70: #4F1140;\n  --green-2: #D9E6C6;\n  --green-3: #578319;\n  --red-1: #FFF7F5;\n  --red-2: #FCBFB3;\n  --red-3: #DD2E0B;\n  --teal-10: #F3FDFB;\n  --teal-20: #A1E5D4;\n  --teal-30: #7ED6C1;\n  --teal-40: #27C4A5;\n  --teal-50: #0E856D;\n  --teal-60: #085243;\n  --teal-70: #04382D;\n  --orange-20: #FFB494;\n  --orange-50: #D04A0A;\n  --orange-60: #942F00;\n  --orange-70: #591E03;\n  --disabled-grey: #C6CACC;\n  --transparent-black-10: rgba(0, 0, 0, 0.1);\n  --transparent-black-85: rgba(0, 0, 0, 0.85);\n  --transparent-white-10: rgba(255, 255, 255, 0.1);\n  --transparent-white-85: rgba(255, 255, 255, 0.85);\n}\n","@import \"_settings.index\";\n.address-container {\n  margin-right: 1.5rem;\n}\n\n.unity-label--above {\n  font-size: 13px;\n  margin-top: 3px;\n  @include desktop {\n    font-size: 1rem;\n    font-weight: 500;\n    width: 100%;\n    margin: 0 1rem 2px 0;\n    line-height: 1.5em;\n  }\n}\n\nods-autosuggest::part(icon) {\n  display: none;\n}\n\nods-autosuggest::part(combobox) {\n  padding-right: 0.5rem;\n}\n","/* Custom-formatted sass/css variables */\n/* Updated 5/15/20 Shao Dai */\n\n/* UPMC white */\n$white: #ffffff; // #ffffff\n\n/* UPMC black */\n$black: #000000; // #000000\n\n/* UPMC grey */\n$grey-10: #F5F5F7; // #F5F5F7\n$grey-20: #DADFE3; // #DADFE3\n$grey-30: #BAC0C2; // #BAC0C2\n$grey-40: #8D9599; // #8D9599\n$grey-50: #666D70; // #666D70\n$grey-60: #3A4042; // #3A4042\n$grey-70: #232526; // #232526\n\n/* UPMC purple */\n$purple-10: #FFFAFF; // #FFFAFF\n$purple-30: #C280BD; // #C280BD\n$purple-50: #9C258B ; // #9C258B\n$purple-60: #771b61; // #771b61\n$purple-70: #4F1140; // #4F1140\n\n/* UPMC green */\n$green-2: #D9E6C6; // #D9E6C6\n$green-3: #578319; // #578319\n\n/* UPMC red */\n$red-1: #FFF7F5; // #FFF7F5\n$red-2: #FCBFB3; // #FCBFB3\n$red-3: #DD2E0B; // #DD2E0B\n\n/* UPMC teal */\n$teal-10: #F3FDFB; // #F3FDFB\n$teal-20: #A1E5D4; // #A1E5D4\n$teal-30: #7ED6C1; // #7ED6C1\n$teal-40: #27C4A5; // #27C4A5\n$teal-50: #0E856D; // #0E856D\n$teal-60: #085243; // #085243\n$teal-70: #04382D; // #04382D\n\n/* UPMC orange */\n$orange-20: #FFB494; // #FFB494\n$orange-50: #D04A0A; // #D04A0A\n$orange-60: #942F00; // #942F00\n$orange-70: #591E03; // #591E03\n\n/* UPMC disabled */\n$disabled-grey: #C6CACC; // #C6CACC\n\n/* UPMC transparent */\n$transparent-black-10: rgba(0, 0, 0, 0.1); // rgba(0, 0, 0, 0.1)\n$transparent-black-85: rgba(0, 0, 0, 0.85); // rgba(0, 0, 0, 0.85)\n$transparent-white-10: rgba(255, 255, 255, 0.1); // rgba(255, 255, 255, 0.1)\n$transparent-white-85: rgba(255, 255, 255, 0.85); // rgba(255, 255, 255, 0.85)\n","\n.error {\n  .unity-select-dropdown:not(.no-error),.unity-input-field{\n    box-shadow: inset 0 0 0 2px #b22116;\n  }\n.error-msg {\n  margin: -6px 0 12px -13px;\n  font-size: 11pt;\n  color: #b22116;\n  padding: 0 0 0 16px;\n  position: relative;\n  display: block;\n  padding-top: 1em;\n\n  animation: fadein 0.5s;\n  -moz-animation: fadein 0.5s;\n  -webkit-animation: fadein 0.5s;\n  -o-animation: fadein 0.5s;\n\n  @keyframes fadein {\n  from {\n  opacity: 0;\n  }\n  to {\n  opacity: 1;\n  }\n  }\n  @-moz-keyframes fadein {\n  from {\n  opacity: 0;\n  }\n  to {\n  opacity: 1;\n  }\n  }\n  @-webkit-keyframes fadein {\n  from {\n  opacity: 0;\n  }\n  to {\n  opacity: 1;\n  }\n  }\n  @-o-keyframes fadein {\n  from {\n  opacity: 0;\n  }\n  to {\n  opacity: 1;\n  }\n  }\n\n  &:before {\n    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIFSURBVEhLrZQxSxxREMfnze2CheAaUqQQzvM2hRC4CBYphKchhaUphED8ACmuECwtErBIkSYgFuks7EyRb3AsBFLJeSEgouFOuIildgfZ7MvM7tzFze7bVfEHdzP/2bt5/903b+GmtHW92VnyT74/97ekVIqSWEhH+88A4ZtIgAhWG8HpZ1FWUGIxCB8kS0B439XVMVFWSpsf6plXFBYSNcK/AqcpuZXCx9LS2nmAv44o9ZNKisso+l2bC84uRWcodO5B/w2FvMaMhxV3U/JcrM7buuopdI/oB48MwIUC80kuEeo1fflUH5ioMjsXHPeSehqrc0RnnRtzTvGw0fr5bvgh/VXqY4ihdTRzm//QVXa7IZIpmAy1dqBn5kWkyG3+B91NBWpcJONIjKGFU4s5iOlRFTLND3SdNtDwRl5nSuKQ+HFdY5FO8IrkIzLNHVTkQqWc3gREtcWjKzIm1ZxWX6SQccCPYXgiuYEB879z5okH52uSx9CG/6OzVG9T6anIW0OL9iei8HEtOBuwHjlPjnlRY7NHTnY58nxLMQUNwdQVuOsiE+clx5zpNVqnNcnpDv0uhelEZRi9FmLnk9Dn1WyNb4tXQectJ4qPOaLLTjwuWCA35qXkNBmwT399KDIHE4YRzCq6xW1Spa/PO/AFaYdfiLhXaNOX0USwY9v9u2NCpczHv0HaiotDFFoAAAAAAElFTkSuQmCC') no-repeat;\n    -webkit-background-size: 13px 13px;\n    background-size: 13px 13px;\n    display: block;\n    content: '';\n    width: 13px;\n    height: 13px;\n    position: relative;\n    left: 0;\n    top: 4px;\n    float: left;\n    padding-right: 19px;\n    }\n  }\n}\n",".no-break{ page-break-inside:avoid; }","/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the grey background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type='button']:-moz-focusring,\n[type='reset']:-moz-focusring,\n[type='submit']:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type='checkbox'],\n[type='radio'] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n","// Base Element Definitions\n// Based on Sanitize CSS: https://github.com/csstools/sanitize.css\n*,\n::before,\n::after {\n  box-sizing: border-box;\n  background-repeat: no-repeat; // S: Backgrounds don't repeat by default.\n}\n/* ::before,\n::after {\n  text-decoration: inherit; // S: Pseudo-elements inherit text-decoration and vertical-align.\n  vertical-align: inherit;\n} */\nhtml {\n  line-height: 1.61803398875; // Based on golden ratio line height. Might switch this to 1.\n  font-family: $unity-font;\n  color: $grey-60;\n  font-size: $text-base-mobile;\n  @include desktop {\n    font-size: $text-base-desktop;\n  }\n  cursor: default; // S: Cursors change to hint non-obvious interfaces.\n  tab-size: 4; // S: Tabs appear the same on web as in a typical editor.\n  //word-break: break-all; // S: Words break to prevent overflow everywhere.\n  //hyphens:auto; // M: This doesn't work with Chrome/FF.\n}\n// Might need to change the text-decoration:none rule.\na,\nbutton {\n  cursor: pointer;\n  text-decoration: none;\n}\n// Reset all base elements that have margin.\n// This and the padding declaration could eventually be removed.\nblockquote,\nbody,\ndd,\ndl,\nfieldset,\nfigure,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nmenu,\nol,\np,\npre,\nul {\n  margin: 0;\n}\n// Reset all base elements that have padding.\nfieldset,\nlegend,\nol,\nul {\n  padding: 0;\n}\nnav ol,\nnav ul {\n  list-style: none; // S: Nav lists contain no decoration.\n}\n::selection {\n  background-color: #b3d4fc; // S: Selection does not include text shadows.\n  color: #000;\n  text-shadow: none;\n}\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n  vertical-align: middle; // S: Media elements align to the text center of other content.\n}\nsvg {\n  fill: currentColor; // S: SVG fallback to current text color.\n}\ntable {\n  border-collapse: collapse; // S: Tables do not include extra spacing at the start.\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: inherit; // S: This may come from normalize as well but this enables form elements to be easily styled.\n  font-size: inherit;\n  line-height: inherit;\n}\ntextarea {\n  resize: vertical; // S: Limit resizing to only vertical.\n}\na,\narea,\nbutton,\ninput,\nlabel,\nselect,\nsummary,\ntextarea,\n[tabindex] {\n  -ms-touch-action: manipulation; // S: Single taps are immediately dispatched on mobile.\n  touch-action: manipulation;\n}\n// S: Aria roles include visual cursor hints.\n[aria-busy='true'] {\n  cursor: progress;\n}\n\n[aria-controls] {\n  cursor: pointer;\n}\n\n[aria-disabled],\n[disabled] {\n  cursor: default;\n}\n// S: Visually hidden content remains accessible.\n[aria-hidden='false'][hidden]:not(:focus) {\n  clip: rect(0, 0, 0, 0);\n  display: inherit;\n  position: absolute;\n}\n","//\n// UPMC Unity Typography\n// Last Author: Mike Markovich - 1/10/18\n//\n\n// FONTS\n// Default UPMC font.\n$unity-font: var(--ods-font-family);\n\n// TYPOGRAPHY\n// All text sizes are based on a 16px default size for desktop, followed by a 14px size for mobile/tablet.\n$text-base-mobile:14px;\n$text-base-desktop:16px;\n$text-weight-normal:400;\n$text-weight-bold:700;\n\n// Jumbo\n// Uses: Page-level heading. Should generally only be used once per page.\n// Mobile/Tablet: 52px\n// Desktop: 60px\n$text-jumbo:3.750rem;\n\n// XX-Large\n// Uses: Page or large section headline or title.\n// Mobile/Tablet: 32px\n// Desktop: 36px\n$text-xx-large:2.25rem;\n\n// X-Large\n// Uses: Section titles.\n// Mobile/Tablet: 25px\n// Desktop: 28px\n$text-x-large:1.750rem;\n\n// Large\n// Uses: Subsection titles.\n// Mobile/Tablet: 19px\n// Desktop: 22px\n$text-large:1.375rem;\n\n// Medium\n// Uses: Body text, default size. Can also be used for small headers, when there is enough stylistic differentiation between header text and body text.\n// Mobile/Tablet: 14px\n// Desktop: 16px\n$text-medium:1rem;\n$text-default:1rem;\n\n// Small\n// Uses: Labels, captions, descriptions.\n// Mobile/Tablet: 11px\n// Desktop: 13px\n$text-small:0.813rem;\n\n// X-Small\n// Uses: Minimum size, used mainly for disclaimers and other fine print. Avoid using, when possible.\n// Mobile/Tablet: 10px\n// Desktop: 12px\n$text-x-small:0.75rem; ","//\n// UPMC Unity Breakpoints\n// Last Author: Shao Dai - 3/10/20\n//\n\n$breakpoint-wide:1280px;\n$breakpoint-desktop:1024px;\n$breakpoint-tablet:768px;\n$breakpoint-narrow:320px;\n\n@mixin tablet {\n  @media (min-width: #{$breakpoint-tablet}) and (max-width: #{$breakpoint-desktop - 1px}) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: #{$breakpoint-tablet}) {\n    @content;\n  }\n}\n\n@mixin tablet-and-up {\n  @media (min-width: #{$breakpoint-tablet}) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media print, (min-width: #{$breakpoint-desktop}) {\n    @content;\n  }\n}\n\n@mixin wide {\n  @media (min-width: #{$breakpoint-wide}) {\n    @content;\n  }\n}\n\n@mixin IE11 {\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
